// AgentDetailsModal.jsx
import { Modal } from "antd";
import "./AgentDetailsModal.scss";
import GaugeChart from "../../../Reuseable/GaugeChart/GaugeChart";
import GreenSmile from "../../../assets/Icons/GreenSmile.svg"
import AgentMapWithPopup from "../AgentDetailsComp/AgentMapWithPopup";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { getFieldAgentCaseDetails } from "../../../assets/api/allocation";
import moment from "moment";

const EMPTY = "—";

const AgentDetailsModal = ({ open, onClose, agent }) => {
  const { token } = useSelector(state => state.auth);
  const [assignedCase, setAssignedCase] = useState({
    loading: false,
    data: {}
  });
  const { feedback_details, case_details } = assignedCase?.data || {}



  useEffect(() => {
    if (!open) return;
    getCaseInfo()
  }, [token, agent])

  const getCaseInfo = async () => {
    try {
      setAssignedCase((prev) => ({
        ...prev,
        loading: true,
        data: {}
      }))
      const res = await getFieldAgentCaseDetails(token, agent?.id);

      setAssignedCase((prev) => ({
        ...prev,
        loading: false,
        data: res?.data?.data || {}
      }))
    } catch (error) {
      setAssignedCase((prev) => ({
        ...prev,
        loading: false,
        data: {}
      }))
    }
  }

  /* Was three hand-built rows of three cells, held together by border rules
     on :last-child plus :nth-child(3)/(6) overrides at one breakpoint - the
     borders broke as soon as a value wrapped. One list, one grid. */
  const reportFields = useMemo(() => {
    const visited = case_details?.visit_datetime
      ? moment.utc(case_details.visit_datetime)
      : null;

    return [
      {
        label: "Date and time of visit",
        value: visited?.isValid()
          ? visited.format("DD MMM YYYY, hh:mm A")
          : null,
        mono: true,
      },
      { label: "Agent name", value: case_details?.agent_name },
      {
        label: "Loan account no.",
        value: case_details?.loan_no,
        mono: true,
      },
      { label: "Customer name", value: case_details?.customer_name },
      { label: "Loan type", value: case_details?.loan_type },
      { label: "Bank / NBFC", value: case_details?.bank_name },
      { label: "City", value: case_details?.city },
      { label: "Pin code", value: case_details?.pincode, mono: true },
      {
        label: "Customer address",
        value: case_details?.customer_address,
        wide: true,
      },
    ];
  }, [case_details]);

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={null}
      width={1060}
      /* was an <h3> inside the body, so antd rendered no header at all and
         the close button floated over the map */
      title={
        <div className="visitTitle">
          <span className="visitTitle__main">Visit Details</span>
          <span className="visitTitle__sub">
            Field visit report · loan collection attempt
          </span>
        </div>
      }
      className="agentModal"
    >
      <AgentMapWithPopup data={{}} data2={assignedCase} isSingle={true} />

      <div className="visit-report">
        <section className="visitSection">
          <header className="visitSection__head">Case &amp; customer</header>
          <div className="visitGrid">
            {reportFields.map(({ label, value, mono, wide }) => (
              <div
                className={`visitItem${wide ? " is-wide" : ""}`}
                key={label}
              >
                <span className="visitItem__label">{label}</span>
                <span
                  className={`visitItem__value${mono ? " is-mono" : ""}${
                    value ? "" : " is-empty"
                  }`}
                >
                  {value || EMPTY}
                </span>
              </div>
            ))}
          </div>
        </section>

        <section className="visitSection">
          <header className="visitSection__head">Visit outcome</header>
          <p className="visitRemark">{feedback_details?.remark || EMPTY}</p>
        </section>

        {/* TODO: placeholder content - these three lines, the sentiment and
            the predicted disposition are hardcoded and are not derived from
            feedback_details. */}
        <section className="visitSection">
          <header className="visitSection__head">
            Next action recommended
          </header>
          <ul className="visitActions">
            <li>Attempt second visit during evening hours or weekend.</li>
            <li>Try contacting the customer on mobile to confirm availability.</li>
            <li>Escalate to supervisor if no response after repeated visits.</li>
          </ul>
        </section>

        <div className="visit-report-footer">
          <div className="footer">
            <p>Sentiment</p>
            <span className="sentimentChip">
              <img src={GreenSmile} alt="" />
              Positive
            </span>
          </div>
          <div className="footer">
            <p>Predicted disposition</p>
            <div className="data-and-graph">
              <div className="data">
                <p className="data-head">May respond in evening</p>
                <strong>78%</strong>
              </div>
              <GaugeChart />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AgentDetailsModal;
